import React from "react";
import { Dropdown } from "components/ui";
import { ReactSVG } from "react-svg";
import imageLinks from "assets/images";
import { POST_FORM_MODAL_ACTIONS } from "../../enum";
import {
    POST_FORM_DELETE_PERMISSION,
    POST_FORM_READ_PERMISSION,
    POST_FORM_UPDATE_PERMISSION,
} from "components/dashboard/KnowledgeBase/PostForms/permissions";
const {
    VIEW_POST_FORM_COLLECTION,
    EDIT_POST_FORM_COLLECTION,
    DELETE_POST_FORM_COLLECTION,
} = POST_FORM_MODAL_ACTIONS;

const PostFormCollectionActionDropdown = ({
    postFormCollection,
    handleActionModal,
}) => {
    return (
        <Dropdown
            size='sm'
            placeholder={
                <ReactSVG
                    src={imageLinks?.icons?.carbonMore}
                    className='d-inline-flex'
                />
            }
            ddValueClass='borderless'
            className='table__dropdown'
            ddOptionsClass='table__dropdown'
            anchor={false}
            changeValue={false}
            onChange={({ value }) =>
                handleActionModal(value, postFormCollection)
            }
            options={[
                {
                    value: VIEW_POST_FORM_COLLECTION,
                    label: "View",
                    baseResources: POST_FORM_READ_PERMISSION,
                },
                {
                    value: EDIT_POST_FORM_COLLECTION,
                    label: "Edit",
                    baseResources: POST_FORM_UPDATE_PERMISSION,
                },
                {
                    value: DELETE_POST_FORM_COLLECTION,
                    label: "Delete",
                    baseResources: POST_FORM_DELETE_PERMISSION,
                },
            ]}
        />
    );
};

export default PostFormCollectionActionDropdown;
